export default {"src":"https://fishbrain.com/_next/static/media/midnight.9556cccc.svg","height":44,"width":64,"blurWidth":0,"blurHeight":0};